import request, {
  convertData,
  MutationOptions,
  useMakeMutation,
} from '@shared/innmaxLib/services'
import React from 'react'
import { useQuery, UseQueryOptions } from 'react-query'
import { useConvertArticle } from './articles.converter'
import { IArticle } from './articles.type'

export const useArticles = (query?: any, options?: UseQueryOptions) => {
  const { converter } = useConvertArticle()

  const { data, ...others } = useQuery(
    ['/article/list/{pageNum}/{pageSize}', query],
    {
      ...options,
    }
  )

  const dataSource = React.useMemo(() => {
    return convertData<IArticle>(
      {
        converter,
      },
      data
    )
  }, [data, converter])

  return {
    ...others,
    dataSource,
    loading: others.isLoading,
  }
}

export const useArticleById = (id?: string, options?: UseQueryOptions) => {
  const { converter } = useConvertArticle()

  const { data: _data, ...others } = useQuery(
    ['/article/detail/{id}', { id }],
    {
      enabled: !!id,
      ...options,
    }
  )

  const data = React.useMemo(() => {
    return converter((_data as any)?.data)
  }, [_data, converter])

  return {
    ...others,
    data,
    loading: others.isLoading,
  }
}

export const useAddArticle = (options: MutationOptions = {}) => {
  return useMakeMutation(
    (values: Partial<any> = {}) =>
      request('/article', {
        method: 'POST',
        body: values,
      }),
    options
  )
}

export const useEditArticle = (options: MutationOptions = {}) => {
  return useMakeMutation(
    (values: Partial<any> = {}) =>
      request(`/article`, {
        method: 'PUT',
        body: values,
      }),
    options
  )
}

export const useDeleteArticle = (options: MutationOptions = {}) => {
  return useMakeMutation(
    ({ id }: { id: string }) =>
      request(`/article/${id}`, {
        method: 'DELETE',
      }),
    options
  )
}
